import { useEffect } from "react";

import { useAuthOptional } from "@/contexts/AuthContext";

const BASE_TITLE = "Gestionalo";

/**
 * Sets document.title to "Gestionalo | {tenantName}" when the user has a tenant,
 * otherwise "Gestionalo". Renders nothing. Uses useAuthOptional so it does not throw
 * when context is temporarily unavailable (e.g. during HMR).
 */
export function PortalDocumentTitle(): null {
  const auth = useAuthOptional();
  const tenantName = auth?.user?.tenantName;

  useEffect(() => {
    document.title = tenantName
      ? `${BASE_TITLE} | ${tenantName}`
      : BASE_TITLE;
  }, [tenantName]);

  return null;
}
